import _slicedToArray from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import safelyParseJson from './safelyParseJson';
import isClient from './isClient';
import isAPISupported from './isAPISupported';
import isDevelopment from './isDevelopment';
/**
 * An utility to quickly create hooks to access both Session Storage and Local Storage
 */

var createStorageHook = function createStorageHook(type) {
  var storageName = "".concat(type, "Storage");

  if (isClient && !isAPISupported(storageName)) {
    // eslint-disable-next-line no-console
    console.warn("".concat(storageName, " is not supported"));
  }
  /**
   * the hook
   */


  return function (storageKey, defaultValue) {
    if (!isClient) {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.warn("Please be aware that ".concat(storageName, " could not be available during SSR"));
      }

      return [JSON.stringify(defaultValue), function () {
        return undefined;
      }];
    }

    var storage = window[storageName];

    var _useState = useState(safelyParseJson(storage.getItem(storageKey) || JSON.stringify(defaultValue))),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    useEffect(function () {
      storage.setItem(storageKey, JSON.stringify(value));
    }, [storageKey, value]);
    return [value, setValue];
  };
};

export default createStorageHook;